
export type Labels = [string, string, string]

export function declinationLabels(count: number, labels: Labels) {
  const cases = [2, 0, 1, 1, 1, 2]

  let index

  if (count % 100 > 4 && count % 100 < 20) {
    index = 2
  } else {
    index = cases[(count % 10 < 5) ? count % 10 : 5]
  }

  return labels[index]
}

export default declinationLabels

export const years: Labels = ['год', 'года', 'лет']
export const months: Labels = ['месяц', 'месяца', 'месяцев']
export const days: Labels = ['день', 'дня', 'дней']
export const hours: Labels = ['час', 'часа', 'часов']
export const minutes: Labels = ['минута', 'минуты', 'минут']
export const seconds: Labels = ['секунда', 'секунды', 'секунд']
export const files: Labels = ['файл', 'файла', 'файлов']
